// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3e3SV","filesListContainer":"PosDisputesFiles_filesListContainer__1ddI_","filesButton":"PosDisputesFiles_filesButton__NJCVA"};